import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b2092cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { ref: "calendarEl" }
const _hoisted_3 = { class: "event-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_wdw_dynbox = _resolveComponent("wdw-dynbox")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_EventDetail = _resolveComponent("EventDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.showFilter)
        ? (_openBlock(), _createBlock(_component_wdw_dynbox, {
            key: 0,
            title: "Filter",
            config: { showControls: true },
            minimize: _ctx.isFilterMinimized,
            watermark: true
          }, {
            default: _withCtx(() => [
              (_ctx.isInitiated && _ctx.calendar)
                ? (_openBlock(), _createBlock(_component_Filter, {
                    key: 0,
                    calendar: _ctx.calendar,
                    cal_config: _ctx.cal_config
                  }, null, 8, ["calendar", "cal_config"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["minimize"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.showEventDetail]
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.isLoadingContent]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
      [_vShow, !_ctx.showEventDetail]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEventDetail()))
      }, "Zurück zum Kalender", 512), [
        [_vShow, _ctx.showEventDetail]
      ]),
      _withDirectives(_createVNode(_component_EventDetail, { privacyPageUrl: _ctx.privacyPageUrl }, null, 8, ["privacyPageUrl"]), [
        [_vShow, _ctx.showEventDetail]
      ])
    ])
  ]))
}